module.exports = __webpack_public_path__ + "assets/5d82bbbca6d53756d943994b7a4b75cc.png";